import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";

const SearchMessageStatus = () => {
  const { userToken, SetSharedObject, sharedObject } = useUserStore(
    (state) => ({
      setCustomerObj: state.setCustomerObj,
      userRole: state.userRole,
      userToken: state.userToken,
      setCustomerFlag: state.setCustomerFlag,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userSession: state.userSession,
    }),
  );

  const [fromAddress, setFromAddress] = useState("");
  const [processing, SetProcessing] = useState(false);
  const [submFlag, setSubmFlag] = useState(false);
  const [sendStatus, setSendStatus] = useState("All");
  const [isMDN, setIsMDN] = useState(null);
  const [date, setDate] = useState(null);
  const [startdate, setStartDate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("MsgStatusSearchModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  useEffect(() => {
    setSubmFlag(false);
    $("#startDate")
      .datepicker()
      .on("changeDate", function (e) {
        setNewDate(e.date);
        setStartDate(new Date(e.date));
        $("#startDate").datepicker("hide");
        let dt = e.date;
        let max = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 30);
        $("#endDate").datepicker("setDate", max);
        $("#endDate").datepicker("show");
      });
    $("#endDate")
      .datepicker()
      .on("changeDate", function (e) {
        setDate(new Date(e.date));
        setEndDate(new Date(e.date));
        $("#endDate").datepicker("hide");
      });
    $("#startDate").datepicker("setDate", getLastWeek());
    $("#endDate").datepicker("setDate", new Date());
    setEndDate(new Date(getLastWeek()));
    setStartDate(new Date());
  }, []);

  const getLastWeek = () => {
    let today = new Date();
    let lastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7,
    );
    return lastWeek;
  };
  const setNewDate = (selected) => {
    let dt = new Date(selected);
    let today = new Date();
    setMinDate(dt);
    let max = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 30);
    setMaxDate(max);
    if (max > today) {
      setMaxDate(today);
    }
    $("#endDate").datepicker("setStartDate", dt);
    $("#endDate").datepicker("setEndDate", max);
    $("#endDate").datepicker("setDate", null);
    setEndDate(null);
  };

  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  async function getMessages() {
    setSubmFlag(true);
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    if (isEmpty(StartDate)) {
      document.getElementById("startDateId").scrollIntoView();
      document.getElementById("startDateId").focus();
      setStartDate(null);
      return;
    } else if (isEmpty(EndDate)) {
      document.getElementById("endDateInput").scrollIntoView();
      document.getElementById("endDateInput").focus();
      setEndDate(null);
      return;
    }
    SetProcessing(true);
    let call = "/directorySearch/GetMessageStatus";
    let search = {};

    if (isMDN === null) {
      search = {
        FromAddress: sharedObject.CurrentFromAddress.directEmailAddress,
        ToAddress: fromAddress,
        StartDate: new Date(StartDate),
        EndDate: new Date(EndDate),
        OrganizationId: sharedObject.CurrentFromAddress.organizationId,
        MessageSource: "Sent",
        sortBy: "SentDate",

        sortDir: "SentDate",
      };
    } else {
      search = {
        FromAddress: sharedObject.CurrentFromAddress.directEmailAddress,
        ToAddress: fromAddress,
        StartDate: new Date(StartDate),
        EndDate: new Date(EndDate),
        Mdn: isMDN,
        OrganizationId: sharedObject.CurrentFromAddress.organizationId,
        MessageSource: "Sent",
        sortBy: "SentDate",
        sortDir: "SentDate",
      };
    }

    let finalSearch = search;
    if (sendStatus !== "All") {
      finalSearch = { ...search, SendStatus: sendStatus };
    }
    const res = await CallAPI(call, finalSearch, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject("previousSearch", finalSearch);
      SetSharedObject("recievedMessageStatusResults", res.data.data.pageItems);
      SetSharedObject("messageStatusResultsFlag", true);
      SetProcessing(false);
    } else {
      SetProcessing(false);
    }
  }

  const changeMDN = (e) => {
    let mdnString = e.target.value;
    let isMDN = null;
    if (mdnString === "All") {
      isMDN = null;
    } else if (mdnString === "Yes") {
      isMDN = true;
    } else if (mdnString === "No") {
      isMDN = false;
    }
    setIsMDN(isMDN);
  };

  const changeAddress = (e) => {
    setFromAddress(e.target.value);
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $("#MsgStatusSearchModal").modal("hide");
  };

  return (
    <div className="SearchMessageStatus">
      <div
        className="modal fade"
        id="MsgStatusSearchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="messagestatus-search-title"
        aria-describedby="messageStatusSearchDesc"
        data-backdrop="static"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline"
                id="messagestatus-search-title"
              >
                Search
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close message status search"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form aria-label="Search message status">
              <div className="modal-body">
                <div
                  className="modal-content-body container"
                  id="messageStatusSearchDesc"
                >
                  {/* Sent To*/}
                  <div className="field-wrapper">
                    <label htmlFor="SentTo">Sent To</label>
                    <input
                      type="email"
                      className="form-control"
                      name="SentTo"
                      id="SentTo"
                      placeholder="Enter Direct Email"
                      autoComplete="email"
                      onChange={changeAddress}
                    />
                  </div>
                  <div className="field-wrapper">
                    {/*Start Date*/}
                    <div className="spacer-margin5 spacer-inline w-md2 v-top">
                      <label htmlFor="startDateId">
                        Start Date
                        <span aria-hidden="true" className="rd-clr">
                          {" "}
                          *
                        </span>
                      </label>
                      <div
                        className="input-group date"
                        data-provide="datepicker"
                        id="startDate"
                        data-date-end-date="1d"
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="StartDate"
                          id="startDateId"
                          autoComplete="off"
                          aria-required="true"
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="input-group-text"
                            id="startDateButton"
                            aria-label="Open start date calendar"
                          >
                            <i
                              className="fas fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </div>
                      {submFlag && isEmpty(startdate) ? (
                        <div
                          className="alert alert-danger"
                          role="alert"
                          id="startDateError"
                          aria-live="assertive"
                          aria-atomic="true"
                        >
                          Start date is required.
                        </div>
                      ) : null}
                    </div>

                    {/*End Date*/}
                    <div className="spacer-inline w-md2 v-top">
                      <label htmlFor="endDateInput">
                        End Date
                        <span aria-hidden="true" className="rd-clr">
                          {" "}
                          *
                        </span>
                      </label>
                      <div
                        className="input-group date end-date"
                        data-provide="datepicker"
                        id="endDate"
                        data-date-start-date={minDate}
                        data-date-end-date={maxDate}
                      >
                        <input
                          type="text"
                          className="form-control"
                          name="EndDate"
                          id="endDateInput"
                          autoComplete="off"
                          aria-required="true"
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            id="endDateButton"
                            className="input-group-text"
                            aria-label="Open end date calendar"
                          >
                            <i
                              className="fas fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </div>
                      {submFlag && isEmpty(enddate) ? (
                        <div
                          className="alert alert-danger"
                          role="alert"
                          aria-live="assertive"
                          aria-atomic="true"
                        >
                          End Date is required.
                        </div>
                      ) : null}
                    </div>
                    <div className="sp-margin13">
                      Set a date range to specify results within 30 days.
                    </div>
                  </div>

                  <div className="field-wrapper">
                    {/*MDN*/}
                    <div className="spacer-margin5 spacer-inline w-md2">
                      <label htmlFor="MessageType">Message Type</label>
                      <select
                        className="form-control"
                        name="MessageType"
                        id="MessageType"
                        onChange={changeMDN}
                      >
                        <option value="All">All</option>
                        <option value="Yes">MDN</option>
                        <option value="No">Not MDN</option>
                      </select>
                    </div>
                    {/*Status*/}
                    <div className="spacer-inline w-md2">
                      <label htmlFor="status">Status</label>
                      <select
                        className="form-control"
                        name="Status"
                        id="status"
                        onChange={(e) => setSendStatus(e.target.value)}
                      >
                        <option value="All">All</option>
                        <option value="Confirmed">Confirmed</option>
                        <option value="Failed">Failed</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={getMessages}
                  ref={firstFocusRef}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                >
                  Cancel
                </button>
                {processing && (
                  <div
                    className="loader-container"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                    aria-labelledby="search-message-status-loader"
                  >
                    <div className="spinner" aria-hidden="true"></div>
                    <div
                      className="loading-text"
                      id="search-message-status-loader"
                    >
                      {loadingText}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchMessageStatus;
